module.exports = "<div class=\"m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-container m-container--responsive m-container--xxl m-container--full-height\">\n\t<div class=\"m-grid__item m-grid__item--fluid m-wrapper\">\n\t\t<router-outlet></router-outlet>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/pages/default/default.component.html
// module id = ./src/app/theme/pages/default/default.component.html
// module chunks = main